import React__default, { useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { FormControl } from '@sravni/react-design-system/lib/FormControl';
import { Space } from '@sravni/react-design-system/lib/Space';
import { TextInput } from '@sravni/react-design-system/lib/TextInput';
import { mergeRefs } from '@sravni/react-utils';
import '../ContextProvider/components/IsLoadingProvider/provider.js';
import { useIsLoading } from '../ContextProvider/components/IsLoadingProvider/hook.js';
import '../ContextProvider/components/IsOTPSendedProvider/provider.js';
import { useIsOTPSended } from '../ContextProvider/components/IsOTPSendedProvider/hook.js';
import '../ContextProvider/components/ValidationContextProvider/provider.js';
import { useValidationContext } from '../ContextProvider/components/ValidationContextProvider/hook.js';

const INPUT_NAME = "email" /* FIELD_NAME.EMAIL */;
const DEFAULT_LABEL = 'Email';
/** Компонент для ввода email пользователя. Будет сохранен в его профиле */
const EmailInput = React__default.forwardRef((props, ref) => {
    const { label = DEFAULT_LABEL, required, onBlur: onBlurOutside, onFocus: onFocusOutside, onChange: onChangeOutside, ...restProps } = props;
    const { control, formState: { errors }, } = useFormContext();
    const [isLoading] = useIsLoading();
    const [isOTPSended] = useIsOTPSended();
    const [_, setValidationContext] = useValidationContext();
    const error = errors[INPUT_NAME];
    useEffect(() => {
        setValidationContext((state) => ({ ...state, [`${INPUT_NAME}Required`]: required }));
    }, [required, setValidationContext]);
    return (React__default.createElement(FormControl, { invalid: !!error },
        React__default.createElement(Space, { direction: "vertical" },
            React__default.createElement(Controller, { name: INPUT_NAME, control: control, render: ({ field: { onBlur, onChange, ...field } }) => (React__default.createElement(TextInput, { ...field, ...restProps, onBlur: (e) => {
                        onBlur();
                        onBlurOutside?.(e);
                    }, onChange: (e) => {
                        onChange(e);
                        onChangeOutside?.(e);
                    }, onFocus: onFocusOutside, readOnly: isLoading || isOTPSended, label: label, ref: mergeRefs(field.ref, ref) })) }),
            React__default.createElement(FormControl.HelperText, null, error?.message))));
});

export { EmailInput };
//# sourceMappingURL=view.js.map
